import React, { useEffect, useState } from "react";
import { css } from "react-emotion";
import { withRedux } from "helpers";
import { getAppNotifications, deleteNotification } from "apis";
import { Button } from "appStyles";

export const tableStyle = css`
  background: white;
  width: 100%;
  width: 100%;
  height: 100%;
  padding: 20px;
  max-height: 70vh;
  overflow-y: scroll;

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
`;

function Notifications({ activeApp: { id: appId }, newId }) {
  const [notifications, setNotifications] = useState([]);
  const [deletedId, setDeleted] = useState(null);
  const [error, setError] = useState(null);

  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentTimeZoneShortName = new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];

  useEffect(() => {
    getNotifications();
  }, [`${deletedId} ${newId}`]);

  const getNotifications = async () => {
    const result = await getAppNotifications(appId);
    setNotifications(result);
  };

  const deleteNotificationCall = async id => {
    try {
      await deleteNotification(id);
      setDeleted(id);
    } catch (e) {
      setError(id);
    }
  };

  const renderScheduled = () => {
    return (
      <div>
        <p>Scheduled Notifications</p>
        <hr style={{ margin: "20px 0px" }}></hr>
        {notifications &&
          notifications
            .sort((a, b) => a.nextSendDate - b.nextSendDate)
            .map(
              ({
                appId,
                endDate,
                id,
                isPushNotification,
                isScheduled,
                nextSendDate,
                repeatingFrequency,
                repeatingInterval,
                retired,
                templateId,
                text,
                title
              }) => {
                const constructDateTimeString = d => {
                  if (!d) {
                    return "";
                  }
                  const dateObject = new Date(d);
                  const date = dateObject.toLocaleDateString();
                  const time = dateObject.toLocaleTimeString();
                  return `${date} ${time} ${currentTimeZoneShortName}`;
                };

                let timeString = `Next notification scheduled for ${constructDateTimeString(
                  nextSendDate
                )}.`;
                if (repeatingFrequency && repeatingInterval) {
                  timeString += ` Repeats every ${repeatingFrequency} `;

                  if (repeatingInterval == "weeks") {
                    timeString += "week(s)";
                  } else if (repeatingInterval == "months") {
                    timeString += "month(s)";
                  } else {
                    timeString += repeatingInterval;
                  }

                  if (endDate) {
                    timeString += `, until ${constructDateTimeString(
                      endDate
                    )}.`;
                  } else {
                    timeString += " indefinitely.";
                  }
                }

                return (
                  <div
                    key={id}
                    style={{
                      padding: "25px",
                      boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                      marginTop: "30px",
                      marginBottom: "30px"
                    }}
                  >
                    {error === id && (
                      <p
                        style={{
                          color: "red"
                        }}
                      >
                        Unable to delete notification
                      </p>
                    )}
                    <h4
                      style={{
                        padding: "15px 0px"
                      }}
                    >
                      {title}
                    </h4>
                    <p
                      style={{
                        padding: "0px 20px 10px 0px",
                      }}
                    >
                      {text}
                    </p>
                    <p
                      style={{
                        padding: "10px 0px",
                        color: "grey"
                      }}
                    >
                      {timeString}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end"
                      }}
                    >
                      <Button
                        background="#F17F7F"
                        width="100px"
                        onClick={() => deleteNotificationCall(id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                );
              }
            )}
        {notifications && notifications.length === 0 && (
          <p>No notification set up</p>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        marginTop: "30px"
      }}
    >
      {renderScheduled()}
    </div>
  );
}

export default withRedux(Notifications);
